module.exports = __webpack_public_path__ + "img/PAULINHO.36980fc9.jpeg";